import * as React from "react";
import {
    Datagrid,
    DateField, DateInput, DateTimeInput,
    DeleteWithConfirmButton, downloadCSV,
    FunctionField,
    List,
    TextField,
    TextInput,
    TopToolbar,
    ExportButton, FilterButton
} from 'react-admin';
import jsonExport from "jsonexport/dist";

const userFilters = [
    <TextInput source="query" label={"Név/Telefonszám"} name={"query"} fullWidth required/>,
    <TextInput source="email" label={"E-mail"} name={"email"} fullWidth required/>,
    <DateTimeInput source="from" name={"registeredFrom"} label={"Regisztrált ettől"}/>,
    <DateTimeInput source="until" name={"registeredFUntil"} label={"Regisztrált eddig"}/>
];

const exporter = (records: any[], fetchRelatedRecords: (arg0: any, arg1: string, arg2: string) => Promise<any>) => {
    // will call dataProvider.getMany('posts', { ids: records.map(record => record.post_id) }), ignoring duplicate and empty post_id
    fetchRelatedRecords([], 'id', 'web-user').then((users: any) => {
        const data = records.map((record: any) => ({
            ...record
        }));
        console.log("data: ", data)
        return jsonExport(
            data,
            {
                headers: [
                    'id',
                    'name',
                    'phone',
                    'email',
                    'registeredAt',
                    'taxNumber',
                ],
                rename: [
                    'ID',
                    'Név',
                    'Telefonszám',
                    'E-mail',
                    'Regisztrálás ideje',
                    'Adószám',
                ],
                rowDelimiter: ';',
            },
            (err, csv) => {
                downloadCSV(csv, 'felhasznalok');
            }
        );
    });
};

const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <ExportButton maxResults={10000} exporter={exporter} />
    </TopToolbar>
);

export const WebUserList = () => (
    <List title={'Felhasználók'}
          actions={<ListActions />}
          sort={{field: 'Default', order: 'DESC'}}
          filters={userFilters}
          sx={{marginBottom: '50px'}}
    >
        <Datagrid bulkActionButtons={false} rowClick={"show"}>
            {/*<TextField source="id" label={"ID"} sortable={false}/>*/}
            <TextField source="name" label={"Név"}/>
            <TextField source="email" label={"E-mail"}/>
            <DateField source="birthDate" locales={['hu-HU']} label={"Születési idő"} sortable={false} emptyText={'-'}/>
            <TextField source="birthPlace" label={"Születési hely"} emptyText={'-'}/>
            <DateField source="registeredAt" locales={['hu-HU']} label={"Regisztrálás ideje"} sortable={false}/>
            <FunctionField
                label=""
                render={(record:any) => {
                    return record.id < 1 ? null : <DeleteWithConfirmButton
                        confirmTitle={"Felhasználó eltávolítása"}
                        confirmContent={"A felhasználó véglegesen törlődik"}
                    />
                }}
            />
        </Datagrid>
    </List>
);
